import { render, staticRenderFns } from "./Shotview.vue?vue&type=template&id=4f04bf5f&scoped=true&"
import script from "./Shotview.vue?vue&type=script&lang=js&"
export * from "./Shotview.vue?vue&type=script&lang=js&"
import style0 from "./Shotview.vue?vue&type=style&index=0&id=4f04bf5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04bf5f",
  null
  
)

export default component.exports